// MessageHelmet.js
import { connect } from 'react-redux';

import MessageHelmet from '../component/MessageHelmet.jsx';
import withRouter from '../component/WithRouter.jsx';

import getMeData from '../selector/getMeData.js';
import getMessageDataWithVariable, {
  VariableName,
} from '../selector/getMessageDataWithVariable.js';
import getUserData from '../selector/getUserData.js';
import getMessageData from '../selector/getMessageData.js';
import getMessageThumbnail from '../selector/getMessageThumbnail.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getAssetData from '../selector/getAssetData.js';
import getNetworkingSummary from '../selector/getNetworkingSummary.js';

import fetchMessageDetail from '../action/fetchMessageDetail.js';
import fetchUser from '../action/fetchUser.js';

const mapStateToProps = (state, { messageId }) => {
  const senderId = getMessageData(state, messageId, 'senderId');
  const unlockPrice = getMessageData(state, messageId, 'unlockPrice');
  const ogMessageThumbnail = getMessageThumbnail(
    state,
    messageId,
    '',
    '512x512',
    'jpg',
    unlockPrice ? 'preview' : 'clear'
  );
  const assetIds = getMessageData(state, messageId, 'assetIds');
  const firstAssetContentType = getAssetData(
    state,
    [assetIds?.[0]],
    'contentType'
  );
  const meUsername = getMeData(state, 'username');
  return {
    messageId,
    ogMessageThumbnail,
    title: getMessageDataWithVariable(
      state,
      messageId,
      'title',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    captionText: getMessageDataWithVariable(
      state,
      messageId,
      'captionText',
      `${VariableName.USERNAME}:${meUsername}`
    ),
    firstAssetContentType,
    senderId,
    senderUsername: getUserData(state, senderId, 'username'),
    isMessageDetailFetched: getNetworkingData(
      state,
      ['messages', messageId, 'detail'],
      'isFetched'
    ),
    isMessageDetailFetching: getNetworkingData(
      state,
      ['messages', messageId, 'detail'],
      'isFetching'
    ),
    isUserDetailFetched: getNetworkingData(
      state,
      ['user', senderId],
      'isFetched'
    ),
    isUserDetailFetching: getNetworkingData(
      state,
      ['user', senderId],
      'isFetching'
    ),
    shouldFetchMessageTranslation: true, // For withFetchTranslation
    assetIds,
    fetchMessageDetailError: getNetworkingSummary(state, [
      'messages',
      messageId,
      'detail',
    ])?.error,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchMessageDetail: ({ id, httpProxyHeaders }) =>
      dispatch(fetchMessageDetail({ id, httpProxyHeaders })),
    fetchUser: ({ id, httpProxyHeaders }) =>
      dispatch(fetchUser({ id, httpProxyHeaders })),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MessageHelmet)
);
